import { InjectionToken } from '@angular/core';

/** True for a Dynamics record id: the 8-4-4-4-12 hex form, braces optional. */
export function isDynamicsGuid(value: string | null | undefined): boolean {
  return !!value && /^\{?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\}?$/i.test(value);
}

/**
 * Turns an appointment reference into the id Dynamics knows the meeting by.
 *
 * A meeting created on the device carries an `offline_meeting_…` id until its
 * upload lands and the real GUID is merged in, so a reference captured before
 * that points at an id the server has never seen. Returns null while the
 * meeting is still device-only; callers hold the record back and retry.
 */
export type AppointmentRefResolver = (appointmentRef: string) => string | null;

/**
 * Resolves through the synced activity set. The default answers only for a
 * reference that is already a GUID, which is what a caller outside the app's
 * root injector gets; APPOINTMENT_REF_RESOLVER_PROVIDER supplies the version
 * that also resolves an offline meeting id.
 */
export const APPOINTMENT_REF_RESOLVER = new InjectionToken<AppointmentRefResolver>(
  'APPOINTMENT_REF_RESOLVER',
  {
    providedIn: 'root',
    factory: () => (appointmentRef: string) => (isDynamicsGuid(appointmentRef) ? appointmentRef : null),
  },
);
